export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAG0lEQVR42mNgYGD4TyEGEuTCUQNGDaCuARRgABWXSsTRWCoiAAAAAElFTkSuQmCC"